<template>
	<div class="newsList">
		<div class="homeTitle">
			<div class="homeTitleText">新闻动态</div>
			<div class="homeTitleLine"></div>
		</div>
		<div class="newsListCon">
			<!-- for循环开始 -->
			<div class="newsListConItem" id="newsListConItem1">
				<div class="newsListConItemLeft">
					<img src="../../../assets/img/news.png" alt="">
				</div>
				<div class="newsListConItemRight">
					<div class="newsListInfoConStarM">
						<span>
							02/16
							<br>
							<font>2023</font>
						</span>
						<h4 @click="showInfo">
							煜豆数字项目集成管理平台亮相—住建部姜万荣副部长视察新城建展览展示中心开展党二十大数字项目集成管理平台亮相—住建部姜万荣副部长视察新城建展览展示中心开展党二十大
						</h4>
					</div>
					<div class="newsListInfoConStarF">
						<p>
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
						</p>
					</div>
				</div>
			</div>
			<div class="newsListConItem" id="newsListConItem2">
				<div class="newsListConItemLeft">
					<img src="../../../assets/img/news1.jpg" alt="">
				</div>
				<div class="newsListConItemRight">
					<div class="newsListInfoConStarM">
						<span>
							02/16
							<br>
							<font>2023</font>
						</span>
						<h4>
							煜豆数字项目集成管理平台亮相—住建部姜万荣副部长视察新城建展览展示中心开展党二十大数字项目集成管理平台亮相—住建部姜万荣副部长视察新城建展览展示中心开展党二十大
						</h4>
					</div>
					<div class="newsListInfoConStarF">
						<p>
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
						</p>
					</div>
				</div>
			</div>
			<div class="newsListConItem">
				<div class="newsListConItemLeft">
					<img src="../../../assets/img/news2.jpg" alt="">
				</div>
				<div class="newsListConItemRight">
					<div class="newsListInfoConStarM">
						<span>
							02/16
							<br>
							<font>2023</font>
						</span>
						<h4>
							煜豆数字项目集成管理平台亮相—住建部姜万荣副部长视察新城建展览展示中心开展党二十大数字项目集成管理平台亮相—住建部姜万荣副部长视察新城建展览展示中心开展党二十大
						</h4>
					</div>
					<div class="newsListInfoConStarF">
						<p>
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
						</p>
					</div>
				</div>
			</div>
			<div class="newsListConItem">
				<div class="newsListConItemLeft">
					<img src="../../../assets/img/news3.jpg" alt="">
				</div>
				<div class="newsListConItemRight">
					<div class="newsListInfoConStarM">
						<span>
							02/16
							<br>
							<font>2023</font>
						</span>
						<h4>
							煜豆数字项目集成管理平台亮相—住建部姜万荣副部长视察新城建展览展示中心开展党二十大数字项目集成管理平台亮相—住建部姜万荣副部长视察新城建展览展示中心开展党二十大
						</h4>
					</div>
					<div class="newsListInfoConStarF">
						<p>
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
							为进一步贯彻党的二十大精神，推进落实住房和城乡建设工作会议工作部署，2月10日下午，部党组成员、副部长姜万荣到部信息中心开展调研，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同，并进行党的二十大精神宣讲，部直属机关党委、信息中心有关负责同
						</p>
					</div>
				</div>
			</div>
			<!-- for循环结束 -->
		</div>
		<!-- 引入组件 -->
		<newsListDetail ref="newsListDetail"></newsListDetail>
	</div>
</template>

<script>
	import newsListDetail from './newsListDetail.vue';
	export default {
		components: {
			newsListDetail
		},
		created() {

		},
		mounted() {

		},
		methods: {
			// 显示详情页
			showInfo() {
				this.$refs.newsListDetail.show()
			},
		}
	}
</script>

<style lang="scss" scoped>
	.newsList {
		width: 65%;
		margin: 0 auto;

		// 标题开始
		.homeTitle {
			width: 100%;
			text-align: center;
			margin: 0 auto;
			margin-bottom: 35px;

			.homeTitleText {
				height: 45px;
				font-size: 31px;
				color: #000;
				font-weight: 500;
				// padding: 60px 0 8px 0;
				padding: 30px 0 8px 0;
			}

			.homeTitleLine {
				width: 64px;
				height: 3px;
				background: #006fff;
				margin: 0 auto;
			}
		}

		// 标题结束

		// 新闻动态列表开始
		.newsListCon {
			margin-bottom: 60px;
			width: 100%;

			.newsListConItem {
				display: flex;
				flex-direction: row;
				// padding-bottom: 12px;
				padding: 25px 0;
				// border-bottom: 1px dotted rgb(238, 238, 238);
				// border-bottom: 1px dashed #eeeeee;
				border-bottom: 1px dashed #dbd4cd;

				.newsListConItemLeft {
					width: 26%;
					border-radius: 5px;
					overflow: hidden;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.newsListConItemRight {
					width: 70%;
					margin-left: 4%;

					.newsListInfoConStarM {
						padding: 18px 0 0 0px;
						display: flex;
						flex-direction: row;
						justify-content: space-between;

						span {
							font-size: 16px;
							width: 7%;
							height: 44px;
							padding-top: 10px;
							text-align: center;
							display: block;
							float: left;
							color: #333;
							background: #f0f2f5;
							border: 1px #e2e3e8 solid;
							border-radius: 10px;

							font {
								font-size: 12px;
							}
						}

						h4 {
							color: #333;
							font-size: 14px;
							font-weight: normal;
							line-height: 22px;
							width: 88%;
							float: right;
							padding: 3px 0 9px 0;
							border-bottom: 1px #e2e3e8 solid;
							height: 45px;
							cursor: pointer;
							// 超过2行...省略
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							line-clamp: 2;
							-webkit-line-clamp: 2; // 想要超出三行显示 就把这里改成3就好了
						}
					}

					.newsListInfoConStarF {
						text-align: left;
						font-size: 12px;
						color: #888;
						padding: 16px 12px 12px 0px;

						p {
							line-height: 26px;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							line-clamp: 4;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 4; // 想要超出三行显示 就把这里改成3就好了
						}
					}

				}
			}
		}

		// 新闻动态列表结束
	}
</style>
